import(/* webpackMode: "eager" */ "/home/runner/work/minimals-showcase/minimals-showcase/src/app/loading.tsx")